import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, Badge, Tooltip, OverlayTrigger, Dropdown } from "react-bootstrap";
import Drawer from '@mui/material/Drawer';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import DatePicker, { DateObject } from "react-multi-date-picker";
import ViewLead from '../../../modal/Lead_Management/Manage_Lead_Calendar/ViewLead';
import ViewCustomer from '../../../modal/Lead_Management/Manage_Lead_Calendar/ViewCustomer';
import ViewSpam from '../../../modal/Lead_Management/Manage_Lead_Calendar/ViewSpam';
import ViewCloudCall from '../../../modal/Lead_Management/Manage_Lead_Calendar/ViewCloudCall';
import axios from "axios";
import LoadingComponent from '../../../layouts/nav/loading';

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Lead_Calendar = () => {

    const defaultPermissions = {
        view_dashboard: 0,
        branch_man: 0,

        // ---------------------- lead ---------------
        lead_man: 0,
        man_lead: 0,
        lead_list: 0,
        lead_add: 0,
        lead_edit: 0,
        lead_followup: 0,
        lead_view: 0,
        lead_import: 0,
        lead_export: 0,
        lead_subscribe: 0,
        lead_approve_spam: 0,
        lead_approve_dead: 0,

        man_coupon: 0,
        coupon_list: 0,
        coupon_add: 0,
        coupon_edit: 0,
        coupon_view: 0,
        points_add: 0,
        points_edit: 0,

        man_followup: 0,
        followup_list: 0,

        man_calls: 0,
        calls_list: 0,
        calls_location: 0,
        calls_add_lead: 0,

        lead_calender: 0,
        calender_list: 0,

        lead_source: 0,
        source_list: 0,

        // -------------------------------- team ---------------------
        team_man: 0,
        team_lead: 0,
        team_lead_list: 0,
        team_followup: 0,
        team_followup_list: 0,
        team_calls: 0,
        team_calls_list: 0,
        team_promise: 0,
        promise_month_list: 0,
        promise_today_list: 0,

        subscri_man: 0,
        subscriber_list: 0,
        subscriber_view: 0,
        subscriber_edit: 0,
        subscriber_filter: 0,
        subscriber_new_subscription: 0,
        subscriber_drop_subscription: 0,

    };

    // Immediately load from localStorage if available
    const initialPermissions = (() => {
        const stored = localStorage.getItem('user_permissions');
        return stored ? JSON.parse(stored) : defaultPermissions;
    })();

    const [permissions, setPermissions] = useState(initialPermissions);

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [calendarData, setCalendarData] = useState({});

    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [selectedMonth, setSelectedMonth] = useState(month_fil_value.getMonth() + 1);
    const [selectedYear, setSelectedYear] = useState(month_fil_value.getFullYear());

    const [total_lead, settotalLead] = useState(0);
    const [total_customer, setTotalCustomer] = useState(0);
    const [total_spam, setTotalSpam] = useState(0);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        axios.post(`${baseURL}/get_year_leadsource/calendar`, {
            month: selectedMonth,
            year: selectedYear,
            branch_id: branch_id
        }).then(response => {
            setCalendarData(response.data.data);
            settotalLead(response.data.total_lead);
            setTotalCustomer(response.data.total_customer);
            setTotalSpam(response.data.total_spam);
            setLoading(false);
        })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setLoading(false);
            });
    }, [selectedMonth, selectedYear]);

    const generateFullMonthCalendar = (year, month) => {
        console.log(year, month);
        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0);
        const totalDays = lastDay.getDate();
        const firstDayOfWeek = firstDay.getDay();

        const weeks = [];
        let dayCounter = 1;
        let week = new Array(7).fill(null);

        for (let i = firstDayOfWeek; i < 7 && dayCounter <= totalDays; i++) {
            week[i] = { day: dayCounter, date: new Date(year, month, dayCounter) };
            dayCounter++;
        }
        weeks.push(week);

        while (dayCounter <= totalDays) {
            week = new Array(7).fill(null);
            for (let i = 0; i < 7 && dayCounter <= totalDays; i++) {
                week[i] = { day: dayCounter, date: new Date(year, month, dayCounter) };
                dayCounter++;
            }
            weeks.push(week);
        }

        return weeks;
    };

    useEffect(() => {
        setCalendarWeeks(generateFullMonthCalendar(selectedYear, selectedMonth - 1));
    }, [selectedMonth, selectedYear]);

    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);

    const [calendarWeeks, setCalendarWeeks] = useState([]);

    const [viewDay, setviewday] = useState(0);

    const handleLeadModalToggle = (day) => {
        setviewday(day);
        setModalType("ViewLead");
        setOpen(true);
    };

    const handlecustomerModalToggle = (day) => {
        setviewday(day);
        setModalType("ViewCustomer");
        setOpen(true);
    };

    const handleSpamModalToggle = (day) => {
        setviewday(day);
        setModalType("ViewSpam");
        setOpen(true);
    };

    const handleCloudModalToggle = () => {
        setModalType("ViewCloud");
        setOpen(true);
    };

    const getDayStatus = date => {
        const today = new Date();
        const td = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        const cd = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        if (cd.getTime() === td.getTime()) return 1; //current
        if (cd.getTime() > td.getTime()) return 2; // future
        return 0; // past
    };

    const handleMonthChange = (dateObject) => {
        if (dateObject instanceof DateObject) {
            const jsDate = dateObject.toDate(); // Convert to JS Date
            setMonthFilValue(jsDate);
            setSelectedMonth(jsDate.getMonth() + 1);
            setSelectedYear(jsDate.getFullYear());
        } else {
            console.log("Invalid date:", dateObject);
        }
    };

    const [isMaintenance, setIsMaintenance] = useState(false);

    useEffect(() => {
        let isMounted = true;

        const checkMaintenanceStatus = async () => {
            try {
                const response = await axios.get(`${baseURL}/maintenance-mode?branch_id=${branch_id}`);
                const data = response.data.data || [];
                const branchStatus = data.find((item) => item.slug === "leadcalendar"); // use managebranch slug

                if (isMounted) {
                    setIsMaintenance(branchStatus?.maintenancemode_status === 1);
                }
            } catch (error) {
                console.error("Error checking maintenance mode:", error);
                if (isMounted) setIsMaintenance(false);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        checkMaintenanceStatus();

        return () => {
            isMounted = false;
        };
    }, [baseURL, branch_id]);


    if (isMaintenance) {
        return (
            <div
                className="d-flex flex-column align-items-center justify-content-center text-center"
                style={{ height: "100vh", width: "100vw" }}
            >
                <h1 className="text-warning mb-3">🚧 Under Maintenance</h1>
                <p className="text-muted fs-5">
                    The <strong>Manage Calendar </strong> module is currently under maintenance. <br />
                    Please check back later.
                </p>
            </div>
        );
    }

    const days = [1, 2, 3, 4, 5, 6, 7];

    return (
        <>
            {loading ? (
                <div className="d-flex justify-content-between page-titles px-0 py-1 mx-0">
                    <div className='mb-0 align-content-center'>
                        <div className="mb-0 px-0">
                            <Skeleton width={200} height={28} /> {/* Title */}
                        </div>
                        <div className="d-flex gap-1 mt-1">
                            <Skeleton width={60} height={16} /> {/* Breadcrumb item */}
                            <Skeleton width={16} height={16} /> {/* Arrow */}
                            <Skeleton width={100} height={16} /> {/* Active breadcrumb */}
                        </div>
                    </div>

                    {/* Middle/Right: Stats Badges */}
                    <div className="d-flex flex-wrap align-items-center mb-1">
                        {['Leads', 'Customers', 'Spam', 'Cloud Call'].map((_, idx) => (
                            <div
                                key={idx}
                                className={`text-center border border-2 p-2 me-2`}
                                style={{ minWidth: '80px' }}
                            >
                                <Skeleton width={60} height={18} className="mb-2" /> {/* Label */}
                                <Skeleton width={30} height={24} borderRadius={12} /> {/* Badge */}
                            </div>
                        ))}
                    </div>

                    {/* Right side: Date Picker */}
                    <div className="d-flex align-items-center justify-content-end mb-1">
                        <div className="w-60 mb-1 col-lg-8">
                            <div className='datepicker-wrapper d-flex align-items-center gap-1'>
                                <Skeleton circle width={36} height={36} /> {/* Calendar icon */}
                                <Skeleton width={120} height={36} /> {/* Date input */}
                                <Skeleton circle width={36} height={36} /> {/* Caret icon */}
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="d-flex justify-content-between page-titles px-0 py-1 mx-0">
                    <div className='mb-0 align-content-center'>
                        <div className="mb-0 px-0">
                            <h4 className='breadcrumb-header'>Manage Lead Calendar</h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                            <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                            <li className="breadcrumb-item active">Lead Management</li>
                        </ol>
                    </div>

                    {permissions.calender_list === 1 && (
                        <div className="d-flex flex-wrap align-items-center mb-1">
                            <div className="text-center border border-2 p-2 me-2" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="Total Leads">
                                <div className="text-black fw-semibold fs-6 mb-2">Leads</div>
                                <div className="d-block">
                                    <div className="badge rounded fw-bold text-white fs-6" style={{ backgroundColor: '#1C9151' }}>{String(total_lead).padStart(2, '0')}</div>
                                </div>
                            </div>
                            <div className="text-center border border-2 p-2 me-2" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="Total Customers">
                                <div className="text-black fw-semibold fs-6 mb-2">Customers</div>
                                <div className="d-block">
                                    <div className="badge rounded fw-bold text-black fs-6" style={{ backgroundColor: '#4CD2FC' }}>{String(total_customer).padStart(2, '0')}</div>
                                </div>
                            </div>
                            <div className="text-center border border-2 p-2 me-2" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="Total Spam Leads">
                                <div className="text-black fw-semibold fs-6 mb-2">Spam</div>
                                <div className="d-block">
                                    <div className="badge rounded fw-bold text-white fs-6" style={{ backgroundColor: '#6D788D' }}>{String(total_spam).padStart(2, '0')}</div>
                                </div>
                            </div>
                            <div className="text-center border border-2 p-2" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="Total Cloud Call Leads">
                                <div className="text-black fw-semibold fs-6 mb-2">Cloud Call</div>
                                <div className="d-block">
                                    <div className="badge rounded fw-bold text-white fs-6" style={{ backgroundColor: '#FF6563' }}>00</div>
                                </div>
                            </div>
                        </div>
                    )}

                    {permissions.calender_list === 1 && (
                        <div className="d-flex align-items-center justify-content-end mb-1">
                            <div className="w-60 mb-1 col-lg-8">
                                <div className='datepicker-wrapper d-flex'>
                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                    <DatePicker format="MMM-YYYY" value={month_fil_value} calendarPosition="top" mode="single" onlyMonthPicker={true} minDate={new Date(1900, 0, 1)} maxDate={new Date()} onChange={handleMonthChange} />
                                    <div className='input-group-text bg-transparent border-0 px-0 py-0' style={{ padding: 0, margin: 0, display: 'flex', alignItems: 'center' }}><i className="fa-solid fa-caret-down fs-4"></i></div>
                                </div>
                            </div>
                        </div>
                    )}

                    {open && modalType === "ViewLead" && (
                        <ViewLead show={open} onClose={() => setOpen(false)} day={viewDay} month={selectedMonth} year={selectedYear} />
                    )}
                    {open && modalType === "ViewCustomer" && (
                        <ViewCustomer show={open} onClose={() => setOpen(false)} day={viewDay} month={selectedMonth} year={selectedYear} />
                    )}
                    {open && modalType === "ViewSpam" && (
                        <ViewSpam show={open} onClose={() => setOpen(false)} day={viewDay} month={selectedMonth} year={selectedYear} />
                    )}
                    {open && modalType === "ViewCloud" && (
                        <ViewCloudCall show={open} onClose={() => setOpen(false)} day={viewDay} month={selectedMonth} year={selectedYear} />
                    )}
                </div>
            )}

            {permissions.calender_list === 1 && (
                <div className="row mx-1">

                    {loading ? (
                        <table className="tables">
                            <thead>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold fs-7">
                                {Array.from({ length: 5 }).map((_, weekIndex) => (
                                    <tr key={weekIndex}>
                                        {days.map((_, dayIndex) => (
                                            <td key={dayIndex} className="emboss-effect table_custom px-3 py-2" style={{ minHeight: '175px' }}>
                                                <div className="mb-2">
                                                    <Skeleton width={24} height={18} borderRadius={4} />
                                                </div>
                                                <div className="d-flex justify-content-between mb-1">
                                                    <Skeleton width={40} height={14} />
                                                    <Skeleton width={24} height={18} borderRadius={12} />
                                                </div>
                                                <Skeleton height={1} className="my-1" />

                                                <div className="d-flex justify-content-between mb-1">
                                                    <Skeleton width={50} height={14} />
                                                    <Skeleton width={24} height={18} borderRadius={12} />
                                                </div>
                                                <Skeleton height={1} className="my-1" />

                                                <div className="d-flex justify-content-between mb-1">
                                                    <Skeleton width={30} height={14} />
                                                    <Skeleton width={24} height={18} borderRadius={12} />
                                                </div>
                                                <Skeleton height={1} className="my-1" />

                                                <div className="d-flex justify-content-between">
                                                    <Skeleton width={60} height={14} />
                                                    <Skeleton width={24} height={18} borderRadius={12} />
                                                </div>
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <table className="tables">
                            <thead className=''>
                                <tr className="text-start text-white fw-bold fs-6 gs-0 px-1 py-0" style={{ backgroundColor: '#1a895e' }}>
                                    <th className='w-100px min-w-100px max-w-125px table_custom px-3 py-2'>Sunday</th>
                                    <th className='w-100px min-w-100px max-w-125px table_custom px-3 py-2'>Monday</th>
                                    <th className='w-100px min-w-100px max-w-125px table_custom px-3 py-2'>Tuesday</th>
                                    <th className='w-100px min-w-100px max-w-125px table_custom px-3 py-2'>Wednesday</th>
                                    <th className='w-100px min-w-100px max-w-125px table_custom px-3 py-2'>Thursday</th>
                                    <th className='w-100px min-w-100px max-w-125px table_custom px-3 py-2'>Friday</th>
                                    <th className='w-100px min-w-100px max-w-125px table_custom px-3 py-2'>Saturday</th>
                                </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold fs-7">

                                {calendarWeeks.map((week, wi) => (
                                    <tr key={wi}>
                                        {week.map((dayObj, di) => {
                                            if (!dayObj) return <td key={di} className="table_custom h-175px w-175px bg-light"></td>;
                                            const { date } = dayObj;
                                            const dayStatus = getDayStatus(date);

                                            return (
                                                <>
                                                    {dayStatus !== 2 ? (
                                                        <>
                                                            {dayStatus === 0 ? ( // past
                                                                <td key={di} className="emboss-effect table_custom px-3 py-1">
                                                                    <div className="d-flex justify-content-start align-items-center mb-2">
                                                                        <div><Badge bg="info" className='py-0 px-1 fs-8'>{String(dayObj.day).padStart(2, '0')}</Badge></div>
                                                                    </div>

                                                                    <div className="d-flex align-items-center justify-content-between gap-2 mb-1">
                                                                        <div className="fs-7 text-black fw-semibold hover-label">Lead</div>
                                                                        <div
                                                                            onClick={() => handleLeadModalToggle(dayObj.day)}
                                                                            className="badge text-white fs-6 fw-semibold rounded"
                                                                            style={{ backgroundColor: '#1C9151', cursor: 'pointer' }}
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#kt_modal_view_lead"
                                                                        >
                                                                            <span data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="View Details">{String(calendarData[dayObj.day]?.lead ?? '00').padStart(2, '0')}</span>
                                                                        </div>
                                                                    </div>
                                                                    <hr className="border-bottom border-dashed border-gray-400i mt-2 mb-2 hover-label" />

                                                                    <div className="d-flex align-items-center justify-content-between gap-2 mb-1">
                                                                        <div className="fs-7 text-black fw-semibold hover-label">Customer</div>
                                                                        <div
                                                                            onClick={() => handlecustomerModalToggle(dayObj.day)}
                                                                            className="badge text-black fs-6 fw-semibold rounded"
                                                                            style={{ backgroundColor: '#4CD2FC', cursor: 'pointer' }}
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#kt_modal_view_customers"
                                                                        >
                                                                            <span data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="View Details">{String(calendarData[dayObj.day]?.customer ?? '00').padStart(2, '0')}</span>
                                                                        </div>
                                                                    </div>
                                                                    <hr className="border-bottom border-dashed border-gray-400i mt-2 mb-2 hover-label" />

                                                                    <div className="d-flex align-items-center justify-content-between gap-2 mb-1">
                                                                        <div className="fs-7 text-black fw-semibold hover-label">Spam</div>
                                                                        <div
                                                                            onClick={() => handleSpamModalToggle(dayObj.day)}
                                                                            className="badge text-white fs-6 fw-semibold rounded"
                                                                            style={{ backgroundColor: '#6D788D', cursor: 'pointer' }}
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#kt_modal_view_spam"
                                                                        >
                                                                            <span data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="View Details">{String(calendarData[dayObj.day]?.spam ?? '00').padStart(2, '0')}</span>
                                                                        </div>
                                                                    </div>
                                                                    <hr className="border-bottom border-dashed border-gray-400i mt-2 mb-2 hover-label" />

                                                                    <div className="d-flex align-items-center justify-content-between gap-2 mb-1">
                                                                        <div className="fs-7 text-black fw-semibold hover-label">Cloud Call</div>
                                                                        <div
                                                                            onClick={() => handleCloudModalToggle(dayObj.day)}
                                                                            className="badge text-white fs-6 fw-semibold rounded"
                                                                            style={{ backgroundColor: '#FF6563', cursor: 'pointer' }}
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#kt_modal_view_cloud_call"
                                                                        >
                                                                            <span data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="View Details">00</span>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            ) : ( // current
                                                                <td key={di} className="emboss-effect table_custom px-3 py-1" style={{ backgroundColor: '#ffc8c7ff' }}>
                                                                    <div className="d-flex justify-content-start align-items-center mb-2">
                                                                        <div><Badge bg="info" className='py-0 px-1 fs-8'>{String(dayObj.day).padStart(2, '0')}</Badge></div>
                                                                    </div>

                                                                    <div className="d-flex align-items-center justify-content-between gap-2 mb-1">
                                                                        <div className="fs-7 text-black fw-semibold ">Lead</div>
                                                                        <div
                                                                            onClick={() => handleLeadModalToggle(dayObj.day)}
                                                                            className="badge text-white fs-6 fw-semibold rounded"
                                                                            style={{ backgroundColor: '#1C9151', cursor: 'pointer' }}
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#kt_modal_view_lead"
                                                                        >
                                                                            <span data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="View Details">{String(calendarData[dayObj.day]?.lead ?? '00').padStart(2, '0')}</span>
                                                                        </div>
                                                                    </div>
                                                                    <hr className="border-bottom border-dashed border-gray-400i mt-2 mb-2 " />

                                                                    <div className="d-flex align-items-center justify-content-between gap-2 mb-1">
                                                                        <div className="fs-7 text-black fw-semibold ">Customer</div>
                                                                        <div
                                                                            onClick={() => handlecustomerModalToggle(dayObj.day)}
                                                                            className="badge text-black fs-6 fw-semibold rounded"
                                                                            style={{ backgroundColor: '#4CD2FC', cursor: 'pointer' }}
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#kt_modal_view_customers"
                                                                        >
                                                                            <span data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="View Details">{String(calendarData[dayObj.day]?.customer ?? '00').padStart(2, '0')}</span>
                                                                        </div>
                                                                    </div>
                                                                    <hr className="border-bottom border-dashed border-gray-400i mt-2 mb-2 " />

                                                                    <div className="d-flex align-items-center justify-content-between gap-2 mb-1">
                                                                        <div className="fs-7 text-black fw-semibold ">Spam</div>
                                                                        <div
                                                                            onClick={() => handleSpamModalToggle(dayObj.day)}
                                                                            className="badge text-white fs-6 fw-semibold rounded"
                                                                            style={{ backgroundColor: '#6D788D', cursor: 'pointer' }}
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#kt_modal_view_spam"
                                                                        >
                                                                            <span data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="View Details">{String(calendarData[dayObj.day]?.spam ?? '00').padStart(2, '0')}</span>
                                                                        </div>
                                                                    </div>
                                                                    <hr className="border-bottom border-dashed border-gray-400i mt-2 mb-2 " />

                                                                    <div className="d-flex align-items-center justify-content-between gap-2 mb-1">
                                                                        <div className="fs-7 text-black fw-semibold ">Cloud Call</div>
                                                                        <div
                                                                            onClick={() => handleCloudModalToggle(dayObj.day)}
                                                                            className="badge text-white fs-6 fw-semibold rounded"
                                                                            style={{ backgroundColor: '#FF6563', cursor: 'pointer' }}
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#kt_modal_view_cloud_call"
                                                                        >
                                                                            <span data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="View Details">00</span>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            )}
                                                        </>

                                                    ) : ( // future
                                                        <td key={di} className=" table_custom px-3 py-1 h-175px w-175px">
                                                            <div className="d-flex justify-content-start align-items-center mb-2">
                                                                <div><Badge bg="info" className='py-0 px-1 fs-8'>{String(dayObj.day).padStart(2, '0')}</Badge></div>
                                                            </div>
                                                            <div className='px-3 py-1 align-content-center text-center'>
                                                                -
                                                            </div>
                                                        </td>
                                                    )}
                                                </>

                                            );
                                        })}
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    )}

                </div>
            )}

            {permissions.calender_list === 0 && (
                <div className='align-content-center' style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: '10%',
                    // height: '100vh',       // full viewport height
                    color: 'red',          // text-danger equivalent
                    fontSize: '24px',      // increase font size
                    fontWeight: 'bold'     // optional for emphasis
                }}>
                    <label>No Access</label>
                </div>
            )}

        </>
    )


}
export default Lead_Calendar;